import React, { createContext, useContext, useState } from 'react';

// Create the context to manage state update permission
const StateUpdateContext = createContext();

export const useStateUpdatePermission = () => useContext(StateUpdateContext);

export const StateUpdateProvider = ({ children }) => {
    const [canUpdateState, setCanUpdateState] = useState(true); // Start with updates enabled

    return (
        <StateUpdateContext.Provider value={{ canUpdateState, setCanUpdateState }}>
            {children}
        </StateUpdateContext.Provider>
    );
};
